import { serviceIcon, Check } from './Icons';

function formatPrice(value, currency = 'KES') {
  if (value == null || Number.isNaN(Number(value))) return null;
  return `From ${currency} ${Number(value).toLocaleString('en-KE')}`;
}

function ServiceCard({ service, currency }) {
  const Icon = serviceIcon(service);
  const price = formatPrice(service.priceFrom, currency);
  return (
    <article className="card svc-card">
      <div className="svc-card__icon">
        <Icon width={26} height={26} />
      </div>
      <h3 className="svc-card__title">{service.title}</h3>
      <p className="svc-card__summary">{service.summary}</p>
      {Array.isArray(service.features) && service.features.length > 0 && (
        <ul className="svc-card__features">
          {service.features.slice(0, 4).map((f) => (
            <li key={f}>
              <Check width={15} height={15} /> {f}
            </li>
          ))}
        </ul>
      )}
      <div className="svc-card__foot">
        {price ? <span className="svc-card__price">{price}</span> : <span className="svc-card__price svc-card__price--muted">Custom quote</span>}
        <a href="#contact" className="link-arrow">
          Enquire →
        </a>
      </div>
    </article>
  );
}

export default function Services({ services, currency }) {
  const items = (services || []).filter((s) => s.category !== 'digital-tool');
  if (items.length === 0) return null;

  return (
    <section className="section" id="services">
      <div className="container">
        <div className="section__head">
          <span className="eyebrow">What we do</span>
          <h2 className="section__title">Installations built for businesses</h2>
          <p className="section__sub">
            Professional CCTV, Wi-Fi and networking — designed, installed and supported end to end.
          </p>
        </div>
        <div className="grid grid--3">
          {items.map((s) => (
            <ServiceCard key={s.slug || s.title} service={s} currency={currency} />
          ))}
        </div>
      </div>
    </section>
  );
}
